import Model from 'flarum/common/Model';
export default class Link extends Model {
  title() {
    return Model.attribute('title').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  url() {
    return Model.attribute('url').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
  isInternal() {
    return Model.attribute('isInternal').call(this);
  }
  isNewtab() {
    return Model.attribute('isNewtab').call(this);
  }
  useRelMe() {
    return Model.attribute('useRelMe').call(this);
  }
  isChild() {
    return Model.attribute('isChild').call(this);
  }
  parent() {
    return Model.hasOne('parent').call(this);
  }
  isRestricted() {
    return Model.attribute('isRestricted').call(this);
  }
  guestOnly() {
    return Model.attribute('guestOnly').call(this);
  }
}
flarum.reg.add('fof-links', 'common/models/Link', Link);